<template>
    <v-footer
      app absolute inset
      color="primary"
    >
      <v-container class="py-0 my-0" fluid>
        <div>
          <nav class="footer-nav">
            <v-container class="pa-0 footer-nav">
              <v-row>
                <v-col :cols="12" :sm="6" :md="3" class="py-4">
                  <div style="height: 46px; margin-bottom: 10px" class="d-flex align-center">
                    Saisonstellen mit Ganzjahresperspektive
                  </div>
                  <div class="social-media">
                    <a href="https://www.facebook.com/Mitarbeitersharing/" target="_blank">
                      <v-icon color="white">mdi-facebook</v-icon>
                    </a>
                    <a href="http://instagram.com/mitarbeitersharing" target="_blank">
                      <v-icon color="white">mdi-instagram</v-icon>
                    </a>
                    <a href="https://www.youtube.com/channel/UCl8vmJqaYiCWsvyZeF9u4kQ" target="_blank">
                      <v-icon color="white">mdi-youtube</v-icon>
                    </a>
                  </div>
                  <ul class="footer-nav__meta">
                    <li
                      v-for="(item, index) in navMeta"
                      :key="index"
                    >
                      <router-link :to="item.href">
                        {{ item.title }}
                      </router-link>
                    </li>
                  </ul>
                </v-col>
                <v-col :cols="12" :sm="6" :md="3" class="py-4">
                  <ul class="footer-nav__job-find">
                    <li
                      v-for="(item, index) in navJobFind"
                      :key="index"
                      @click="scrollToSameRoute(item.href)"
                      :style="index === 0 ? 'line-height: 46px; height: 46px; margin-bottom: 10px' : ''"
                    >
                      <router-link :to="item.href">
                        {{ item.title }}
                      </router-link>
                    </li>
                  </ul>
                </v-col>
                <v-col :cols="12" :sm="6" :md="3" class="py-4">
                  <ul class="footer-nav__job-advertisement">
                    <li
                      v-for="(item, index) in navJobAdvertisement"
                      :key="index"
                      @click="scrollToSameRoute(item.href)"
                      :style="index === 0 ? 'line-height: 46px; height: 46px; margin-bottom: 10px' : ''"
                    >
                      <router-link :to="item.href">
                        {{ item.title }}
                      </router-link>
                    </li>
                  </ul>
                </v-col>
                <v-col :cols="12" :sm="6" :md="3" class="py-4">
                  <ul class="footer-nav__jobs2share">
                    <li
                      v-for="(item, index) in navJobs2Share"
                      :key="index"
                      @click="scrollToSameRoute(item.href)"
                      :style="index === 0 ? 'line-height: 46px; height: 46px; margin-bottom: 1px' : ''"
                    >
                      <router-link :to="item.href">
                        {{ item.title }}
                      </router-link>
                    </li>
                    <template v-if="!maintenanceActive">
                      <li>
                        <a @click="openNewsletterRegistrationDialog()">
                          {{ $t('content.newsletter.label') }}
                        </a>
                      </li>
                      <li v-if="authUser">
                        <a @click="openContactFormDialog()">
                          {{ $t('content.contact.label') }}
                        </a>
                      </li>
                    </template>
                  </ul>
                </v-col>
              </v-row>
            </v-container>
          </nav>
        </div>
      </v-container>
    </v-footer>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapUserState } = createNamespacedHelpers('user');

export default {
  props: {
    authReady: {
      type: Boolean,
    },
  },
  data() {
    return {
      socialMediaImagePath: '/static/social-media/',
      lastRoute: null,
    };
  },
  computed: {
    ...mapUserState([
      'maintenanceActive',
      'authUser',
      'language',
    ]),
    navJobs2Share() {
      const items = [
        {
          title: this.$i18n.t('content.jobs2share.label'),
          href: { name: 'page.about', hash: '', params: { lang: this.language } },
          show: true,
        },
        {
          title: this.$i18n.t('content.sponsorship.label'),
          href: { name: 'page.about', hash: '#section-1', params: { lang: this.language } },
          show: true,
        },
        {
          title: this.$i18n.t('content.partner.label'),
          href: { name: 'page.about', hash: '#section-2', params: { lang: this.language } },
          show: true,
        },
        {
          title: this.$i18n.t('content.media.label'),
          href: { name: 'page.about', hash: '#section-3', params: { lang: this.language } },
          show: !this.maintenanceActive,
        },
      ];
      return items.filter((item) => item.show);
    },
    navJobAdvertisement() {
      const items = [
        {
          title: this.$i18n.t('content.jobAdvertisement.label'),
          href: { name: 'page.job-advertisement', hash: '', params: { lang: this.language } },
          show: true,
        },
        {
          title: this.$i18n.t('content.howItWorksEmployer.label'),
          href: { name: 'page.job-advertisement', hash: '#section-1', params: { lang: this.language } },
          show: true,
        },
        {
          title: this.$i18n.t('content.advantagesEmployer.label'),
          href: { name: 'page.job-advertisement', hash: '#section-2', params: { lang: this.language } },
          show: true,
        },
        {
          title: this.$i18n.t('content.offerEmployers.label'),
          href: { name: 'page.job-advertisement', hash: '#section-3', params: { lang: this.language } },
          show: true,
        },
        {
          title: this.$i18n.t('content.employersSays.label'),
          href: { name: 'page.job-advertisement', hash: '#section-4', params: { lang: this.language } },
          show: true,
        },
        {
          title: this.$i18n.t('content.faqsEmployers.label'),
          href: { name: 'page.job-advertisement', hash: '#section-5', params: { lang: this.language } },
          show: true,
        },
      ];
      return items.filter((item) => item.show);
    },
    navJobFind() {
      const items = [
        {
          title: this.$i18n.t('content.jobFind.label'),
          href: { name: 'page.find-a-job', hash: '', params: { lang: this.language } },
          show: true,
        },
        {
          title: this.$i18n.t('content.howItWorksEmployee.label'),
          href: { name: 'page.find-a-job', hash: '#section-1', params: { lang: this.language } },
          show: true,
        },
        {
          title: this.$i18n.t('content.advantagesEmployee.label'),
          href: { name: 'page.find-a-job', hash: '#section-2', params: { lang: this.language } },
          show: true,
        },
        {
          title: this.$i18n.t('content.furtherEducation.label'),
          href: { name: 'page.employee.further-education', params: { lang: this.language } },
          show: true,
        },
        {
          title: this.$i18n.t('content.advantagesEmployee.unemploymentBenefits'),
          href: { name: 'page.employee.seco-pilot', params: { lang: this.language } },
          show: true,
        },
        {
          title: this.$i18n.t('content.employeesSays.label'),
          href: { name: 'page.find-a-job', hash: '#section-3', params: { lang: this.language } },
          show: true,
        },
        {
          title: this.$i18n.t('content.faqsEmployees.label'),
          href: { name: 'page.find-a-job', hash: '#section-4', params: { lang: this.language } },
          show: true,
        },
      ];
      return items.filter((item) => item.show);
    },
    navMeta() {
      const items = [
        {
          title: this.$i18n.t('content.impress.label'),
          href: { name: 'page.impress', params: { lang: this.language } },
          show: true,
        },
        {
          title: this.$i18n.t('content.tac.label'),
          href: { name: 'page.agb', params: { lang: this.language } },
          show: true,
        },
        {
          title: this.$i18n.t('content.privacyPolicy.label'),
          href: { name: 'page.agb', params: { lang: this.language } },
          show: true,
        },
      ];
      return items.filter((item) => item.show);
    },
  },
  methods: {
    openContactFormDialog() {
      this.$eventBus.$emit('show-contact-form-dialog');
    },
    openNewsletterRegistrationDialog() {
      this.$eventBus.$emit('show-newsletter-registration-dialog');
    },
    scrollToSameRoute(href) {
      if (this.lastRoute !== null) {
        if (this.lastRoute.name === href.name && this.lastRoute.hash === href.hash) {
          this.$vuetify.goTo(href.hash);
        }
      }
      this.lastRoute = href;
    },
  },
};
</script>
